import { on } from '@ngrx/store';

import { createImmutableReducer } from '../../base/store/helpers';
import { pickSelectionHandlers } from '../picks/reducer';
import BetbuilderActions from './actions';
import { IBetBuilderBetState, defaultBetBuilderBetState } from './models';

export const betBuilderReducer = createImmutableReducer(
    defaultBetBuilderBetState,
    ...pickSelectionHandlers<IBetBuilderBetState>(),
    on(BetbuilderActions.addPick, (state, action) => {
        state.picks[action.pickId] = {
            isSelected: true,
            rewardTokenId: null,
            stake: null,
            actualStake: null,
            isLocked: false,
            ...action.pickState,
        };

        return state;
    }),
    on(BetbuilderActions.removePick, (state, action) => {
        delete state.picks[action.pickId];

        return state;
    }),
    on(BetbuilderActions.setPickStake, (state, action) => {
        const pickId = action.pickId;
        if (!state.picks[pickId]) {
            return state;
        }
        state.picks[pickId].stake = action.stake;
        state.picks[pickId].actualStake = action.stakeStr || null;

        return state;
    }),
    on(BetbuilderActions.setPickStakes, (state, action) => {
        const picks = Object.values(state.picks);

        for (const pick of picks) {
            pick.stake = action.stake;
            pick.actualStake = action.stakeStr || null;
        }

        return state;
    }),
    on(BetbuilderActions.setPickRewardToken, (state, action) => {
        const { pickId, rewardTokenId } = action;
        if (!state.picks[pickId]) {
            return state;
        }
        state.picks[pickId].rewardTokenId = rewardTokenId;

        return state;
    }),

    on(BetbuilderActions.removeAllPickRewardTokens, (state, action) => {
        for (const pick of Object.values(state.picks)) {
            pick.rewardTokenId = null;
        }

        return state;
    }),
);
